import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import type { Block, DesignRow } from '../types/editor.types';
import { generateId } from '../utils';

interface BlocksState {
  blocks: Block[];
  addBlock: (name: string, category: string, tags: string[], row: DesignRow) => void;
  removeBlock: (id: string) => void;
  updateBlock: (id: string, updates: Partial<Pick<Block, 'name' | 'category' | 'tags'>>) => void;
}

export const useBlocksStore = create<BlocksState>()(
  persist(
    immer((set) => ({
      blocks: [],

      addBlock: (name, category, tags, row) =>
        set((s) => {
          s.blocks.unshift({
            id: generateId(),
            name, category, tags,
            design: row,
            createdAt: new Date().toISOString(),
          });
        }),

      removeBlock: (id) =>
        set((s) => { s.blocks = s.blocks.filter((b: Block) => b.id !== id); }),

      updateBlock: (id, updates) =>
        set((s) => {
          const idx = s.blocks.findIndex((b: Block) => b.id === id);
          if (idx !== -1) s.blocks[idx] = { ...s.blocks[idx], ...updates } as Block;
        }),
    })),
    { name: 'design-studio-blocks' }
  )
);
